export enum VIPChannel {
  Wholesale = 'VIPChannel:Wholesale',
  Retail = 'VIPChannel:Retail'
}
